import { chileanRoutes } from "@/dynamic.routes";
import { redirectIfAuthenticated } from "@/authentication";

export default [{
        path: "/",
        redirect: "/login"
    },{
        path: "/login",
        name: "newlogin",
        component: () => import("@/views/NewLogin.vue"),
        beforeEnter: redirectIfAuthenticated
    },{
        path: "/registrar",
        name: "register",
        component: () => import("@/views/NewRegister.vue"),
        props: true,
        beforeEnter: redirectIfAuthenticated
    },{
        path: '/registro/:tipo?',
        name: "register-requests",
        component: () => import("@/views/NewRegister.vue"),
        props: true,
        beforeEnter: redirectIfAuthenticated
    },{
        path: "/recuperar",
        name: "recuperar",
        component: () => import("@/views/Recover.vue")
    },{
        path: "/recuperar/:token",
        name: "recuperar contraseña",
        component: () => import("@/views/NewPassword.vue"),
        props: true
    },{
        path: "/contacto",
        name: "contact",
        component: () => import("@/views/Contact.vue")
    },{
        path: "/login-company",
        name: "login-alternativo",
        component: () => import("@/views/alternateLogin/alternateLogin.vue"),
        beforeEnter: chileanRoutes
    },{
        path: "/ingreso_clave_sii/:token",
        name: "ingreso-claveSii",
        component: () => import("@/views/claveSii/ClaveSii.vue"),
        props: true
    },{
        path: "/enrolamiento-cliente/:token?",
        name: "enrolamiento-cliente",
        component: () => import("@/views/enrolamiento/EnrolamientoCliente.vue"),
        props: true
    },
]
